import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {

  constructor(private readonly http: HttpClient) { }

  getAdActivityLogs(params: any): any {
    return this.http.get(`${environment.apiUrl}/AuditLog/GetAdActivityLogs`, { params });
  }

  getAllAdActionType(): any {
    return this.http.get(`${environment.apiUrl}/AuditLog/GetAllAdActionType`);
  }

  getAdActivityDetails(id: number): any {
    return this.http.get(`${environment.apiUrl}/AuditLog/GetAdActivityDetails?logId=${id}`);
  }

  getAuditLogRequestOrResponse(params: any): any {
    return this.http.get(`${environment.apiUrl}/AuditLog/GetAuditLogRequestOrResponse`, { params });
  }


}
